import type { ItemIndice } from './busca';
import type { ItemMenu, MenuModulo } from './indice';

function contem(itens: ItemMenu[], rotina: string): boolean {
  return itens.some((i) => i.codigo === rotina || contem(i.itens, rotina));
}

/**
 * Módulo do menu lateral ao abrir uma rotina. Fica no módulo de onde o usuário veio quando o menu dele tem a rotina — Clientes aberto em
 * Compras › Cadastros continua em Compras (vínculo do CFG190). Senão, o módulo em que a rotina aparece para ele (índice, que respeita os menus do
 * grupo), e por último o módulo dono da rotina.
 */
export function moduloDaRotina(rotina: string, moduloRotina: string, contexto: string | null, menuContexto: MenuModulo | undefined,
  indice: ItemIndice[] | undefined): string {
  if (contexto && menuContexto?.modulo.codigo === contexto && contem(menuContexto.grupos, rotina)) return contexto;
  return indice?.find((i) => i.codigo === rotina)?.modulo ?? moduloRotina;
}
